import c from "classnames";

import { Skeleton } from "@design-system/Skeleton/Skeleton";

import classes from "./Avatar.module.css";

type Size = "xs" | "sm" | "md" | "lg" | "xl";

const sizeMap = {
  xs: 24,
  sm: 32,
  md: 48,
  lg: 64,
  xl: 80,
} as const;

type Props = {
  name?: string;
  size?: Size;
};

export const Avatar = ({ name, size = "md" }: Props) => {
  return (
    <div className={c(classes.avatar, classes[size], !name && classes.loading)}>
      {name ? (
        name.charAt(0)
      ) : (
        <Skeleton circle width={sizeMap[size]} height={sizeMap[size]} />
      )}
    </div>
  );
};
